<!--
 * @Author: Tina Huang
 * @Date: 2023-01-02 11:23:12
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-01-02 11:39:46
 * @Description: 
-->
<template>
  <div class="container wrapper">
    <el-divider
      >您的鼓励是我最大的动力！</el-divider
    >
    <div class="btn-box">
      <el-button type="danger" round @click="show_reward = true"
        >赞赏</el-button
      >
    </div>
    <div class="reward-box" v-show="show_reward">
      <div>
        <img src="../assets/reward.jpg" alt="微信" />
        <p>微信</p>
      </div>
      <div>
        <img src="../assets/reward-alipay.jpg" alt="支付宝" />
        <p>支付宝</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show_reward: false,
    };
  },
};
</script>
<style lang="less" scoped>
.container {
  font-size: 16px;
  margin-top: 100px;
  .btn-box {
    text-align: center;
    margin-bottom: 15px;
  }
  .reward-box {
    width: 100%;
    display: flex;
    justify-content: space-around;
    & > div {
      width: 30%;
      text-align: center;
      img {
        width: 100%;
      }
    }
  }
}
</style>
